import React from "react";
import { Container, Typography, Button, Stack } from "@mui/material";

const CoachingHome = ({ setView }) => {
	  const buttons = [
		      { label: "Coaching", view: "coaching" },
		      { label: "Certificates of Achievement", view: "certificate" },
		    ];

	  return (
		      <Container maxWidth="md" sx={{ mt: 4 }}>
		        <Typography variant="h4" gutterBottom>
		          Coaching
		        </Typography>
		        <Stack spacing={2}>
		          {buttons.map(({ label, view, variant }) => (
				            <Button
				              key={view}
				              variant={variant || "text"}
				              onClick={() => setView(view)}
				            >
				              {label}
				            </Button>
				          ))}
		        </Stack>
		      </Container>
		    );
};

export default CoachingHome;

